@if (offen()) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="tad__overlay" (click)="schliessen()">
    <div
      class="tad"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      cdkTrapFocus
      [attr.aria-label]="'kontoApiTokens.dialog.titel' | translate"
      (click)="$event.stopPropagation()"
      (keydown.escape)="escape()"
    >
      <div class="tad__titel">{{ 'kontoApiTokens.dialog.titel' | translate }}</div>

      <div class="tad__inhalt">
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          subscriptSizing="dynamic"
          class="tad__feld tc-field tc-field--uppercase-label"
        >
          <mat-label>{{ 'kontoApiTokens.dialog.name' | translate }}</mat-label>
          <input
            #nameFeld
            matInput
            required
            maxlength="255"
            autocomplete="off"
            data-testid="token-name"
            [placeholder]="'kontoApiTokens.dialog.namePlatzhalter' | translate"
            [formControl]="nameControl"
            [errorStateMatcher]="nameFehlerMatcher"
            (input)="nameEingabe()"
          />
          @if (sichtbarerNameFehler(); as fehler) {
            <mat-error>{{ fehler | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          floatLabel="always"
          subscriptSizing="dynamic"
          class="tad__feld tad__feld--ablauf tc-field tc-field--uppercase-label"
          data-testid="token-ablauf"
        >
          <mat-label>{{ 'kontoApiTokens.dialog.ablauf' | translate }}</mat-label>
          <mat-select #ablaufAuswahl [value]="ablauf()" (valueChange)="ablauf.set($event)">
            @for (option of ablaufOptionen; track option.key) {
              <mat-option [value]="option.wert">
                {{ 'kontoApiTokens.dialog.ablaufOption.' + option.key | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="tad__rechte-label" id="tad-rechte-label">{{ 'kontoApiTokens.dialog.rechte' | translate }}</div>
        @switch (katalogZustand()) {
          @case ('geladen') {
            <div class="tad__chips" role="group" aria-labelledby="tad-rechte-label">
              @for (scope of rechte(); track scope) {
                <button
                  type="button"
                  class="tad__chip"
                  data-testid="token-recht"
                  [attr.data-scope]="scope"
                  [class.tad__chip--aktiv]="istGewaehlt(scope)"
                  [attr.aria-pressed]="istGewaehlt(scope)"
                  [attr.aria-disabled]="gesperrt().has(scope) ? 'true' : null"
                  (click)="umschalten(scope)"
                >
                  {{ label(scope) }}
                </button>
              }
            </div>
          }
          @case ('fehler') {
            <div class="tad__katalog-fehler" role="alert">
              <span>{{ 'kontoApiTokens.dialog.rechteFehler' | translate }}</span>
              <button type="button" class="tad__erneut" data-testid="token-rechte-erneut" (click)="katalogLaden()">
                {{ 'kontoApiTokens.erneutVersuchen' | translate }}
              </button>
            </div>
          }
          @default {
            <div class="tad__katalog-laedt" role="status">
              <mat-progress-spinner mode="indeterminate" diameter="16" />
              {{ 'kontoApiTokens.dialog.rechteLaden' | translate }}
            </div>
          }
        }
      </div>

      <div class="tad__fuss">
        <button
          type="button"
          class="tad__sekundaer"
          data-testid="token-anlegen-abbrechen"
          [disabled]="busy()"
          (click)="schliessen()"
        >
          {{ 'kontoApiTokens.dialog.abbrechen' | translate }}
        </button>
        <button
          type="button"
          class="tad__primaer"
          data-testid="token-anlegen-bestaetigen"
          [disabled]="!kannAnlegen()"
          (click)="bestaetigen()"
        >
          {{ 'kontoApiTokens.dialog.anlegen' | translate }}
        </button>
      </div>
    </div>
  </div>
}
